import axios, { AxiosPromise } from 'axios';

const isValidParam = (param: any) => {
  if (param === null || param === undefined) return false;
  if (typeof param === 'number') return true;
  if (typeof param === 'boolean') return true;
  return param.length > 0;
};

const generateUrl = (baseUrl: string, params: { [key: string]: any }) => Object.keys(params)
  .filter((element) => isValidParam(params[element]))
  .reduce((acc, cur) => `${acc}&${cur}=${params[cur]}`, `${baseUrl}?`)
  .replace('?&', '?');

const get = (
  url: string,
  params: { [key: string]: any } = {},
): AxiosPromise => axios({
  method: 'get',
  url: generateUrl(url, params),
});

const ApiClient = {
  get,
  generateUrl,
};

export default ApiClient;
